import { combineReducers } from '@reduxjs/toolkit';

import { partsAll } from './all/partsAll';
import { partsAllList } from './all/partsAllList';
import { partsNoAccount } from './all/partsNoAccount';
import { partsNoAccountList } from './all/partsNoAccountList';
import { parts } from './core/parts';
import { partsList } from './core/partsList';

export default combineReducers({
    partsAll,
    partsAllList,
    partsNoAccount,
    partsNoAccountList,
    parts,
    partsList,
});
